import { TableColumnOption } from '../../components/table-pro/table.config';

export enum ArchiveFileGroupStatus {
  INCOMPLETE = 'INCOMPLETE',
  COMPLETE = 'COMPLETE',
  ABNORMAL = 'ABNORMAL',
  UPDATED = 'UPDATED',
}

export const ArchiveFileGroupStatusMap = {
  [ArchiveFileGroupStatus.INCOMPLETE]: '未完成',
  [ArchiveFileGroupStatus.COMPLETE]: '齐全',
  [ArchiveFileGroupStatus.ABNORMAL]: '异常',
  [ArchiveFileGroupStatus.UPDATED]: '已更新',
};

export const ArchiveFileGroupStatusOptions: TableColumnOption[] = [
  {
    value: ArchiveFileGroupStatus.INCOMPLETE,
    label: ArchiveFileGroupStatusMap[ArchiveFileGroupStatus.INCOMPLETE],
  },
  {
    value: ArchiveFileGroupStatus.COMPLETE,
    label: ArchiveFileGroupStatusMap[ArchiveFileGroupStatus.COMPLETE],
  },
  {
    value: ArchiveFileGroupStatus.ABNORMAL,
    label: ArchiveFileGroupStatusMap[ArchiveFileGroupStatus.ABNORMAL],
  },
  {
    value: ArchiveFileGroupStatus.UPDATED,
    label: ArchiveFileGroupStatusMap[ArchiveFileGroupStatus.UPDATED],
  },
];

export const ArchiveFileGroupStatusOptionsDisplay: TableColumnOption[] = [
  {
    value: ArchiveFileGroupStatus.COMPLETE,
    label: ArchiveFileGroupStatusMap[ArchiveFileGroupStatus.COMPLETE],
  },
  {
    value: ArchiveFileGroupStatus.ABNORMAL,
    label: ArchiveFileGroupStatusMap[ArchiveFileGroupStatus.ABNORMAL],
  },
];
